import {Service, service, inject} from "./di";
import {ConfigService} from "./ConfigService";
import {LocationService} from "./LocationService";


@service("BlackFridayService")
export class BlackFridayService extends Service {
	@inject config: ConfigService;
	@inject location: LocationService;

	isEnabled() {
		return this.config.IS_BLACKFRIDAY === "true";
	}

	isOnHost() {
		return location.hostname === this.config.BF_HOSTNAME || this.isOnRendora();
	}

	// checking if the Javascript is being run on Rendora
	// is_bf is being sent on nginx server
	// location:4000 - is Rendora host
	isOnRendora() {
		return location.host === "localhost:4000" && location.search.includes("is_bf=1");
	}

	getHostLink() {
		const path = this.location.locale === "fr-ca" ? "fr-ca/flyers" : "weekly_ads";
		return `${window.location.protocol}//${this.config.BF_HOSTNAME}/${path}/${this.config.BF_CATEGORY}?postal_code=${this.location.postalCode}`;
	}

	redirectToHost() {
		window.location.href = this.getHostLink();
	}

	shouldRenderBlogSection() {
		return false;
	}
}
